import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./UsersGroupList.module.css";
import UserGroupItem from "../UserGroupItem";
import RemoveGroupModal from "../RemoveGroupModal";

const groupInfo = {
  name: "Albus And Minerva Mcgongall Diamonship",
  groupType: "Diamonship",
  status: "yes",
  pluginType: "None",
  notes: "This is the note..",
};

/**
 * Interactive component. List of users groups with a header.
 */
export function UsersGroupList({ groups }) {
  const [removeGroupModalOpen, setRemoveGroupModalOpen] = useState(false);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.headerGrid}>
          <div className={styles.headerItem}>Group Name</div>
          <div className={styles.headerItem}>Group Type</div>
          <div className={styles.headerItem}>Status</div>
          <div className={styles.headerItem}>Plugin Type</div>
          <div className={styles.headerItem}>Notes</div>
        </div>

        <div className={styles.usersContainer}>
          {groups.map((group, index) => (
            <div
              className={
                index % 2 === 0 ? styles.backgroundWhite : styles.backgroundGray
              }
            >
              <UserGroupItem
                groupInfo={{
                  name: group.name,
                  groupType: group.groupType,
                  status: group.status,
                  pluginType: group.pluginType,
                  notes: group.notes,
                }}
                onRemove={() => {
                  setRemoveGroupModalOpen(true);
                }}
              />
            </div>
          ))}
        </div>

        <RemoveGroupModal
          isOpen={removeGroupModalOpen}
          groupInfo={groupInfo}
          onClose={() => setRemoveGroupModalOpen(false)}
          onClick={() => alert("Remove group Clicked ")}
        />
      </div>
    </>
  );
}

UsersGroupList.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object),
};
